import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Loader2 } from 'lucide-react';

export function EditUserDialog({ editUser, setEditUser, editPlan, setEditPlan, editRole, setEditRole, editCredits, setEditCredits, saving, onSave }) {
  return (
    <Dialog open={!!editUser} onOpenChange={(open) => { if (!open) setEditUser(null); }}>
      <DialogContent className="bg-[#0E1830] border-white/10 max-w-md" data-testid="edit-user-dialog">
        <DialogHeader>
          <DialogTitle className="text-white font-space">Edit User</DialogTitle>
        </DialogHeader>
        {editUser && (
          <div className="space-y-5 pt-2">
            <div className="flex items-center gap-3 pb-4 border-b border-white/[0.06]">
              <div className="w-10 h-10 rounded-full pi-gradient flex items-center justify-center text-white font-bold">
                {editUser.name?.[0]?.toUpperCase() || 'U'}
              </div>
              <div>
                <p className="text-white font-medium">{editUser.name}</p>
                <p className="text-white/40 text-xs">{editUser.email}</p>
              </div>
            </div>

            <div>
              <Label className="text-white/60 mb-2 block">Plan</Label>
              <Select value={editPlan} onValueChange={setEditPlan}>
                <SelectTrigger className="bg-white/5 border-white/10 text-white"><SelectValue /></SelectTrigger>
                <SelectContent className="bg-[#0E1830] border-white/10">
                  <SelectItem value="free" className="text-white hover:bg-white/5">Free</SelectItem>
                  <SelectItem value="starter" className="text-white hover:bg-white/5">Starter</SelectItem>
                  <SelectItem value="pro" className="text-white hover:bg-white/5">Pro</SelectItem>
                  <SelectItem value="team" className="text-white hover:bg-white/5">Team</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label className="text-white/60 mb-2 block">Role</Label>
              <Select value={editRole} onValueChange={setEditRole}>
                <SelectTrigger className="bg-white/5 border-white/10 text-white"><SelectValue /></SelectTrigger>
                <SelectContent className="bg-[#0E1830] border-white/10">
                  <SelectItem value="user" className="text-white hover:bg-white/5">User</SelectItem>
                  <SelectItem value="admin" className="text-white hover:bg-white/5">Admin</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label className="text-white/60 mb-2 block">Credits remaining</Label>
              <Input type="number" value={editCredits} onChange={(e) => setEditCredits(e.target.value)}
                className="bg-white/5 border-white/10 text-white" />
            </div>

            <div className="flex gap-3 pt-2">
              <Button onClick={onSave} disabled={saving}
                className="shimmer-btn text-white rounded-full px-6 border-0 flex-1" data-testid="save-user-btn">
                {saving ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
                Save changes
              </Button>
              <Button variant="outline" onClick={() => setEditUser(null)}
                className="border-white/10 text-white/50 hover:bg-white/5 rounded-full px-6">Cancel</Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
